import React from "react"
import {connect} from "react-redux"
import {withCommands} from "./CommandsProvider"

export const QueryForm = withCommands(
  connect(function mapStateToProps(state, props) {

    const { isQueryExecuted, isQueryValid } = state.manageTool;
    return {
      ...props,
     isQueryExecuted, isQueryValid
    }
  }, function mapDispatchToProps(dispatch, props) {
    return {
      ...props,
      onSubmit() {
        props.commands.submitQuery()
      }
    }


  })(
    ({
       children,
       onSubmit,
       isQueryValid,
       isQueryExecuted
     }) => {
      return <div>
        <form onSubmit={(e) => {
          isQueryValid && onSubmit()
          e.preventDefault()
        }}>
          {children}
          <hr />
          <div className="clearfix" >
            <button className="pull-right btn btn-secondary" type="submit" disabled={!isQueryValid || isQueryExecuted}>Search</button>
          </div>
        </form>
      </div>
    }
  )
)
